enum ModGroupDisplayStyle {
  Carousel = 'carousel',
  Default = 'default',
  Quantity = 'quantity',
  RowSizeGroup = 'row-size-group',
  SizeGroup = 'size-group',
  Slider = 'slider',
}

export { ModGroupDisplayStyle };
